<template>
    <div class="flex justify-center">
        <div class="w-full sm:w-80" :class="fieldName ? 'h-20' : ''">
            <label
                v-if="fieldName"
                :for="identification"
                class="block text-gray-700 text-sm font-bold mb-1"
            >
                {{ fieldName }}
                <span v-show="isRequired" class="text-primary-emphasis">*</span>
            </label>
            <div v-if="disabled" class="py-2 px-3">
                <span>{{ value }}</span>
            </div>
            <input
                v-else
                :id="identification"
                v-model="field"
                :name="identification"
                :required="isRequired"
                class="shadow appearance-none border rounded h-10 w-full py-2 lg:px-3 px-2 mb-0 leading-tight focus:outline-none focus:shadow-outline dark:bg-slate-950 bg-white text-primary-dark dark:text-white"
                :class="{
                    'border-red-500': showErrorMessage,
                    'border-operations-primary': showSuccess
                }"
                :type="type"
                :placeholder="placeholder"
                :aria-label="fieldName"
                @blur="blurAction"
                @input="inputAction"
                @keyup.enter="keyupEnter"
            />
            <span
                v-show="showErrorMessage"
                class="text-red-500 text-xs italic mt-1"
            >
                {{ messageError }}
            </span>
        </div>
    </div>
</template>

<script>
import { toCapitalized } from "@/common/lib/formatters";

export default {
    name: "InputComponent",
    model: {
        prop: "value",
        event: "update:value"
    },
    props: {
        fieldName: {
            type: String,
            default: () => "fieldName",
            required: true
        },
        value: {
            type: String,
            default: () => "",
            required: true
        },
        id: {
            type: String,
            required: false,
            default: () => ""
        },
        placeholder: {
            type: String,
            default: () => "",
            required: false
        },
        type: {
            type: String,
            default: () => "text",
            required: false
        },
        showSuccess: {
            type: Boolean,
            required: false,
            default: () => false
        },
        showErrorMessage: {
            type: Boolean,
            required: false,
            default: () => false
        },
        messageError: {
            type: String,
            required: false,
            default: () => "Ingresa un valor valido"
        },
        isRequired: {
            type: Boolean,
            required: false,
            default: () => false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: () => false
        },
        lowerCase: {
            type: Boolean,
            required: false,
            default: () => false
        },
        capitalized: {
            type: Boolean,
            required: false,
            default: () => false
        }
    },
    emits: ["blur", "input", "enter", "update:value"],
    data() {
        return {
            field: ""
        };
    },
    computed: {
        identification() {
            return this.id || `input-${this.fieldName}`;
        }
    },
    watch: {
        value(value) {
            this.field = value;
        }
    },
    mounted() {
        this.field = String(this.value);
    },
    methods: {
        blurAction() {
            this.$emit("update:value", this.field);
            this.$emit("blur");
        },
        inputAction() {
            this.field = `${this.field}`.trim();
            if (this.lowerCase) {
                this.field = this.field.toLowerCase();
            } else if (this.capitalized) {
                this.field = toCapitalized(this.field);
            }
            this.$emit("update:value", this.field);
            this.$emit("input");
        },
        keyupEnter() {
            this.$emit("enter");
        }
    }
};
</script>
